import { React, useEffect, useState } from 'react';
import { Row, Col, Button, Modal, Space, message, DatePicker, Form, Tag } from 'antd';
import { ExclamationCircleOutlined, HeartOutlined, PlusOutlined } from '@ant-design/icons';
import axios from "axios";
import NewTable from "./components/NewTable";
import TutionFeeDetailModal from './components/TuitionFeeDetailModal';
import dayjs from 'dayjs';
import { Navigate, Outlet, useNavigate, useLocation, useParams } from 'react-router-dom'
import AddTuitionModal from './components/AddTuitionModal';
const { confirm } = Modal;

const AdminLessonTuitionOverview = () => {
    const navigate = useNavigate();
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, set_loading] = useState(0);
    const [force_reload, set_force_reload] = useState(0)
    const [title, setTitle] = useState();
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [editcard, setEditCard] = useState({});
    const [color, setColor] = useState('d65b77');
    const [messageApi, contextHolder] = message.useMessage();
    const [datas, setDatas] = useState([])
    const [default_column, set_default_column] = useState([
        {
            title: '課程',
            key: 'lesson_name',
            dataIndex: 'lesson_name',
            align: 'center',
        },
        {
            title: '班級',
            key: 'class_name',
            dataIndex: 'class_name',
            align: 'center',
        },
        {
            title: '繳費區間',
            key: 'teacher_data',
            dataIndex: 'teacher_data',
            align: 'center',
            render: (text, record, index) => {
                return <Space >
                    <>
                        {record.payment_time_start}
                    </>
                    <>
                        -
                    </>
                    <>
                        {record.payment_time_end}
                    </>

                </Space>
            }
        },
        {
            title: '授課老師',
            key: '',
            dataIndex: 'teacher_data',
            align: 'center',
            render: (text, record, index) => {
                return <Space>
                    {text.map((value) => {
                        return <Tag color='gold'>{value?.teacher_name ?? "-"}</Tag>
                    })}
                </Space>
            }
        },
        // {
        //     title: '授課時間',
        //     key: 'week_time_data',
        //     dataIndex: 'week_time_data',
        //     align: 'center',
        //     // render: (text, record, index) => {
        //     //     return <Space direction='vertical'>
        //     //         {text.map((value) => {
        //     //             return <Tag color='gold'>{value?.teacher_name ?? "-"}</Tag>
        //     //         })}
        //     //     </Space>
        //     // }
        // },
        {
            title: '班級明細',
            key: 'bill_payment_grade_class_Salary_TABLE_Formula_data',
            dataIndex: 'bill_payment_grade_class_Salary_TABLE_Formula_data',
            align: 'center',
            render: (text, record, index) => {
                return <Space direction='vertical'>
                    {text.map((value) => {
                        return <Tag color='cyan'>{value?.cName ?? "-"}</Tag>
                    })}
                </Space>
            }
        },
        {
            title: '操作',
            align: 'center',
            sorter: false,
            render: (text, record, index) => {
                let FormulaRule_data = record?.FormulaRule_data ?? []
                let detail_data = FormulaRule_data.find((_) => { return true })
                let lesson_salary_table_formula = record?.lesson_salary_table_formula ?? []
                let lesson_id = lesson_salary_table_formula.map((value) => { return value?.lesson_id })
                let data = { ...record, lesson_id: lesson_id, ...detail_data, tActivationTime: dayjs(record?.tActivationTime) }
                return <>
                    <Button
                        type="primary"
                        onClick={() => {
                            handleAddTuition(record)
                        }}
                    >建立班級繳費項目
                    </Button>
                </>
            }

        },
    ]);
    const [form] = Form.useForm();
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [expectForm] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const [tuitionValues, setTuitionValues] = useState(null)

    const get_datas = (param, sort, filter, checklist) => {
        set_loading(true);
        axios
            .get(`/cramSchool/api/bill_payment_grade_class`, {
                params: {
                    cur_page: param?.current,
                    size: param?.pageSize,
                    // custom_filter_key: checklist,
                    // custom_filter_value: param?.keyword,
                    // order: sort && Object.entries(sort).map(([map_key, map_value]) => ({ column: map_key, type: map_value }))
                }
            })
            .then((response) => {
                set_total(response.data.total)
                setDatas(response.data.data);
            })
            .finally(() => {
                set_loading(false)
            })
    }
    const reload = () => {
        set_force_reload(prev => prev + 1)
    }
    useEffect(() => {
        get_datas()
    }, []);
    const handleOnAddRow = () => {
        setTitle('新增種類');
        setColor('d65b77');
        setEdit(false);
        setOpen(true);
        setEditCard({});
        form.resetFields()
    }
    const handleOnDeleteRow = (bill_payment_id) => {
        let data = []
        if (bill_payment_id) {
            data = [{
                bill_payment_id: bill_payment_id
            }]
        }
        else {
            if (selectedRowKeys.length === 0) {
                messageApi.open({
                    type: 'error',
                    content: '請選擇資料',
                });
            }
            else {
                data = selectedRowKeys.map((value) => {
                    return {
                        bill_payment_id: value
                    }
                })
            }
        }
        if (data.length > 0) {
            axios
                .delete(`/cramSchool/api/bill_payment_grade_class`,
                    {
                        data
                    }
                )
                .then((response) => {
                    if (response.data.status === 'success') {
                        setOpen(false);
                        messageApi.open({
                            type: 'success',
                            content: '刪除成功',
                        });
                        reload()
                    } else {
                        setOpen(false);
                        messageApi.open({
                            type: 'error',
                            content: '刪除失敗',
                        });
                        reload()
                    }
                })
        }

    }

    const handleEdit = (values) => {
        console.log({ values })
        if (values?.iFormulaID === undefined) {
            values.iFormulaID = 1
        }
        if (values?.iSerialID === undefined) {
            values.iSerialID = '';
        }
        let lesson_salary_table_formula = values?.lesson_id.map((value) => {
            return {
                "amount": 1,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })
        let data = {
            "cSaveType": "edit",
            "aData": [
                {
                    "iFormulaID": values.iFormulaID,
                    "cName": values?.cName,
                    "iSign": '1',
                    "iFormulaType": values?.iFormulaType,
                    "tRemark": values?.tRemark,
                    "FormulaRule_data": [
                        {
                            "iRuleID": values?.iRuleID,
                            "cOperator": "*",
                            "fNumeric": values?.fNumeric,
                        }],
                    lesson_salary_table_formula: lesson_salary_table_formula

                }

            ]
        }
        axios
            .post(`/Salary/formula/dataSave`,
                data
            )
            .then((response) => {
                if (response.data.status === 'failed') {
                    setOpen(false);
                    messageApi.open({
                        type: 'error',
                        content: '修改失敗',
                    });
                    reload();
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '修改成功',
                    });
                    reload();
                }
            })
    }
    const handleSubmit = (values) => {
        console.log({ values })
        if (values.iFormulaID === undefined) {
            values.iFormulaID = 0
        }
        let lesson_Salary_TABLE_Formula = values?.lesson_id.map((value) => {
            return {
                "amount": 1,
                "lesson_id": value,
                "last_edit_user": 215
            }
        })

        let data = {
            "cSaveType": "new",
            "aData": [
                {
                    "iFormulaID": 0,
                    "cName": values?.cName,
                    "iSign": '1',
                    "iFormulaType": values?.iFormulaType,
                    "tRemark": values?.tRemark,
                    "FormulaRule_data": [
                        {
                            "iRuleID": values?.iRuleID,
                            "cOperator": "*",
                            "fNumeric": values?.fNumeric,
                        }],
                    lesson_Salary_TABLE_Formula: lesson_Salary_TABLE_Formula
                }
            ]

        }
        axios
            .post(`/Salary/formula/dataSave`,
                data
            )
            .then((response) => {
                if (response.data.status === 'failed') {
                    messageApi.open({
                        type: 'error',
                        content: '新增失敗 代碼編號記得不能填相同！',
                    });
                } else {
                    setOpen(false);
                    messageApi.open({
                        type: 'success',
                        content: '新增成功',
                    });
                    reload();
                }
            })
            .finally(() => {

            })

    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        expectForm.resetFields()
    }
    const onFormFinish = (value) => {

    }
    const handleAddTuition = (record) => {
        setColor('d65b77');
        setEdit(false);
        setEditCard({});
        setOpen(true);
        form.resetFields()
        let grade_class_data = record?.grade_class_data ?? []
        let grade_class_first_data = grade_class_data.find((element) => { return true })
        let grade_class_id = grade_class_first_data?.grade_class_id
        let lesson_class_data = record?.lesson_class_data ?? []
        let lesson_class_data_first = lesson_class_data.find(ele => true)
        setTuitionValues({
            ...record,
            ...lesson_class_data_first,
            grade_class_id: grade_class_id
        })
    }
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                {contextHolder}
            </Col>
            <Col span={24}>
                {/* <TutionFeeDetailModal
                    open={open}
                    setOpen={setOpen}
                    edit={edit}
                    title={title}
                    color={color}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    handleEdit={handleEdit}
                    handleSubmit={handleSubmit}
                    form={form}
                /> */}
                    <Button
                        type='primary'
                        onClick={() => {
                            handleAddRow()
                        }}
                        style={{
                            backgroundColor: "#FFF9C9",
                            color: "#000"
                        }}
                    >
                        + 新增繳費期
                    </Button>
                <AddTuitionModal
                    select_mode={true}
                    // defaultValue={}
                    open={open}
                    setOpen={setOpen}
                    editcard={editcard}
                    setEditCard={setEditCard}
                    color={color}
                />
                <Row gutter={[8, 16]}>
                    <Col span={24}>
                        <NewTable
                            total={total}
                            extra_columns={extra_columns}
                            set_extra_columns={set_extra_columns}
                            loading={loading}
                            page_name={'AdminLessonTuitionOverview'}
                            force_reload={force_reload}
                            columns={default_column.concat(extra_columns || [])}
                            getData={get_datas}
                            datas={datas}
                            other={false}
                            add_button_title={'新增班級繳費項目'}//新增按鈕上的名稱
                            handleOnAddRow={handleOnAddRow}//新增row 內容
                            rowkey={'bill_payment_id'}//key
                            setSelectedRowKeys={setSelectedRowKeys}
                            selectedRowKeys={selectedRowKeys}
                            handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
                        ></NewTable>
                    </Col>
                </Row>
            </Col>

        </Row>
    )
}
export default AdminLessonTuitionOverview;